import React from "react";
import { Table } from "react-bootstrap";
import ToggleBar from "../../commoncomponents/toggleBar";
import { utcToDDMMYYYY, dayToHour } from "../../../utils/dateConvert";
import { rounding } from "../../../utils/math";
import moment from "moment-timezone";
import { downloadCSVFile } from "../../../api/apiClient";
import { NavLink } from "react-router-dom";
import ShowIButtonName from "../../commoncomponents/showIButtonName";

function DailySummary(props) {
    const reports = props.reportDetails.dayTrips;
    let assetName = props.assetCustomerName;
    let timeZone = props.calendarSelectedDate ? props.calendarSelectedDate.toString().slice(25, 55) : '';
    let asset_id = props.assetId;
    let iButtonName = props.reportDetails.iButtonName;
    let ibuttonId = props.reportDetails.ibuttonId;
    let serialno = props.reportDetails.serialno;
    
    console.log("report detail in daily summary", props);
    const weekDayFinder = (dayProp) => {
        let dayNumber = moment(dayProp).day();
        switch (dayNumber) {
            case 1: return "Monday";
            case 2: return "Tuesday";
            case 3: return "Wednesday";
            case 4: return "Thursday";
            case 5: return "Friday";
            case 6: return "Saturday";
            case 0: return "Sunday";
            default: return null;
        }
    };

    const hasTempB = reports.some(report => report.tempB > 0);

    const data = (
        <Table responsive striped>
            <thead>
                <tr className="nowwrapTH">
                    <th>Day</th>
                    <th>Date</th>
                    <th>Asset</th>
                    <th>Depot</th>
                    <th>Timezone</th>
                    <th>Start Date</th>
                    <th
                        style={{
                        width: "150px",
                        minWidth: "150px",
                        whiteSpace: "nowrap",
                        }}
                    >
                        End Date
                    </th>
                    <th>Total Days</th>
                    <th>Days in use</th>
                    <th>Utilisation</th>
                    <th>Trips</th>
                    <th>Virtual Trips</th>
                    <th>All Trips</th>
                    {/* <th>
                        Duration&nbsp;{" "}
                        <i
                            class="fa fa-info-circle text-primary"
                            title="First Engine ON to Last Engine OFF"
                        ></i>
                    </th>
                    <th>
                        Duration Outside Depot&nbsp;{" "}
                        <i
                            class="fa fa-info-circle text-primary"
                            title="First Departure until Last Entry or Engine OFF"
                        ></i>
                    </th> */}
                    <th>Engine Hours</th>
                    <th>
                        Moving Engine Hours&nbsp;{" "}
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Engine Hours - Virtual Parked"
                        ></i>
                    </th>
                    <th>Idling Hours</th>
                    <th>
                        Moving Engine Hours Outside&nbsp;{" "}
                        <i
                        class="fa fa-info-circle text-primary"
                        title="Total moving engine hours outside depot"
                        ></i>
                    </th>
                    <th>Parked</th>
                    <th>
                        Total Parked &nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Parked + Virtual Parked"
                        ></i>
                    </th>
                    <th>Distance</th>
                    {/* <th>
                        Average Journey&nbsp;{" "}
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Engine Hours / All Trips"
                        ></i>
                    </th>
                    <th>
                        Average Parked &nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Total Parked / All Trips"
                        ></i>
                    </th>
                    <th>
                        Average Distance &nbsp;
                        <i
                            class="fa fa-info-circle text-primary"
                            title="Distance / All Trips"
                        ></i>
                    </th> */}
                    <th>Parked Idle</th>
                    <th>Duress</th>
                    <th>Powercut</th>
                    <th>Low Battery</th>
                    <th>Temp A</th>
                    {hasTempB && <th>Temp B</th>}
                    <th>Overspeed</th>
                    <th>Harsh Accel</th>
                    <th>Harsh Brake</th>
                    <th>Harsh Corner</th>
                    <th>OH&S</th>
                    <th>GSM Loss</th>
                    <th>GPS Loss</th>
                    <th>Processed</th>
                </tr>
            </thead>
            <tbody>
                {reports.map((report, index) => {
                    return (
                        <tr className={report.allTrips == 0 ? "yellowBg" : ""}>
                            <td>{weekDayFinder(report.dateTime)}</td>
                            <td style={{ whiteSpace: "nowrap" }}>

                                <NavLink title={`View MVTL for this date`} to={`/Rpt-MVTL?assetId=${asset_id}&assetName=${report.asset}&assetDate=${moment(report.dateTime).format("YYYY-MM-DD")}`} target="_blank">{utcToDDMMYYYY(report.dateTime)}</NavLink>
                                {/* <a href="#" onClick={reportMvtlog(asset_id,search_date,Timezone,user_filtering)}>{utcToDDMMYYYY(report.dateTime)}</a> */}
                            </td>

                            <td>{report.asset}
                                <br />
                                <ShowIButtonName
                                    ibuttonId={ibuttonId}
                                    serialno={serialno}
                                    iButtonName={iButtonName}
                                />
                            </td>
                            <td>{report.depot}</td>
                            <td>{report.timezone}</td>
                            <td style={{ whiteSpace: "nowrap" }}>
                                {utcToDDMMYYYY(report.startDate)}
                            </td>
                            <td
                                style={{
                                width: "100",
                                minWidth: "100",
                                whiteSpace: "nowrap",
                                }}
                            >
                                {moment(report.endDate).format("DD-MM-YYYY")}
                            </td>
                            <td>{report.totalDays}</td>
                            <td>{report.daysInUse}</td>
                            <td>{report.utilisation}%</td>
                            <td>{report.trips}</td>
                            <td>{report.virtualTrips}</td>
                            <td>{report.allTrips}</td>
                            {/*<td>{utcToReportDate(report.start)}</td>*/}
                            {/*<td>{utcToReportDate(report.end)}</td>*/}
                            {/* <td>{dayToHour(report.duration)}</td>
                            <td>{dayToHour(report.durationOutsideDepot)}</td> */}
                            <td>{dayToHour(report.engineHours)}</td>
                            <td>{dayToHour(report.movingEngineHours)}</td>
                            <td>{dayToHour(report.idlingHours)}</td>
                            <td>{dayToHour(report.movingEngineHoursOutside)}</td>
                            <td>{report.parked}</td>
                            <td>{report.totalParked}</td>
                            <td>{report.distance}</td>
                            {/* <td>{report.averageJourney}</td>
                            <td>{report.averageParked}</td>
                            <td>{rounding(report.averageDistance)}</td> */}
                            <td>{report.parkedIdle}</td>
                            <td>{report.duress}</td>
                            <td>{report.powercut}</td>
                            <td>{report.lowBattery}</td>
                            <td>{report.tempA}</td>
                            {hasTempB && <td>{report.tempB}</td>}
                            <td>{report.speed}</td>
                            <td>{report.harshAccel}</td>
                            <td>{report.harshBrake}</td>
                            <td>{report.harshCorner}</td>
                            <td>{report.ohs}</td>
                            <td>{report.gsmLoss}%</td>
                            <td>{report.gpsLoss}%</td>
                            <td>{report.processed}</td>
                        </tr>
                    );
                })}
            </tbody>
        </Table>
    );
    const handleDownloadExcel = () => {
        // alert("clicked")
        downloadCSVFile(props.reportDetails.dayTrips, "AssetRunning_DailySummary", assetName, timeZone);
    };
    return (
        <ToggleBar
            download={handleDownloadExcel}
            caption="Daily Summary"
            icon="fa-calendar-o"
            color="#337AB7"
            content={data}
        />
    );
}

export default DailySummary;
